import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'ht',
    fullName: 'Haitian Creole',
    nativeName: 'Haitian Creole',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Yon bagay etonan ap vini",
    landing_subtitle: "ArgVoid se yon estidyo devlopman app ak jwèt. Rete branche, nouvo bagay ap vini byento!",
    select_language: "Chwazi Lang",
    search_placeholder: "Chèche lang...",
    terms_title: "Regleman Sèvis",
    policy_title: "Règleman sou enfòmasyon prive",
    cookies_title: "Règleman bonbon",
    terms_content: `
        <strong>1. Akseptasyon kondisyon </strong><br>
        Lè w gen aksè nan ArgVoid, yo aksepte Kondisyon Sèvis sa yo. Si kondisyon sa yo pa dakò, sèvis la pa ta dwe itilize.<br><br>

        <strong>2. Itilizasyon platfòm</strong><br>
        Yo bay ArgVoid ak aplikasyon li yo "jan yo ye" pou rezon enfòmasyon ak kreyatif. Yo dwe itilize sèvis la sèlman pou rezon legal.<br><br>

        <strong>3. Konduit entèdi</strong><br>
        Eksplwate vilnerabilite sit la, spam, oswa eseye aksè san otorizasyon nan enfrastrikti a se entèdi entèdi.<br><br>

        <strong>4. Limit responsabilite nou</strong><br>
        Platfòm la ak sèvis yo ka modifye nenpòt ki lè san avètisman. Pa gen okenn garanti konsènan disponiblite a oswa disponiblite sèvis la.
    `,
    policy_content: `
        <strong>1. Koleksyon Enfòmasyon </strong><br>
        Platfòm nan pa egzije otantifikasyon itilizatè oswa kreyasyon kont nan moman sa a. Pa gen okenn enfòmasyon pèsonèl idantifikasyon (tankou non oswa adrès imel) aktivman kolekte nan men vizitè yo.<br><br>

        <strong>2. Itilizasyon Data</strong><br>
        Yo ka kolekte analiz debaz, anonimize pou konprann trafik sit la ak amelyore aplikasyon yo. Done sa yo pa lye ak idantite itilizatè endividyèl yo.<br><br>

        <strong>3. Sèvis Twazyèm Pati</strong><br>
        Yo ka itilize founisè twazyèm pati pou sèvis hosting ak analiz. Pratik enfòmasyon prive founisè respektif sa yo gouvène done anonim yo trete sou enfrastrikti yo.<br><br>

        <strong>4. Sekirite Done</strong><br>
        Yo aplike mezi sekirite rezonab pou pwoteje platfòm la. Sepandan, pa gen okenn metòd transmisyon sou Entènèt ki totalman an sekirite.<br><br>
    `,
    cookies_content: `
        <strong>1. Ki sa ki bonbon ak depo lokal yo?</strong><br>
        Bonbon ak depo lokal navigatè yo se ti fichye done ki estoke sou aparèy la pou sonje preferans konfigirasyon atravè vizit yo.<br><br>

        <strong>2. Itilizasyon Objektif</strong><br>
        Navigatè LocalStorage itilize entèdi pou sove paramèt konfigirasyon, tankou:<br>
        - Preferans lang<br>
        - Konfigirasyon koòdone itilizatè (egzanp, layout oswa anviwònman tèm) <br>
        - Aplikasyon tanporè cache<br><br>

        <strong>3. Pa gen Tracking</strong><br>
        Yo pa itilize bonbon ak depo lokal pou fè piblisite oswa pou fè swivi twazyèm pati. Tout done ki estoke se entèdi pou fonksyonalite debaz platfòm la.<br><br>

        <strong>4. Control</strong><br>
        Done navigatè yo ka efase nenpòt ki lè atravè paramèt navigatè yo, ki pral reset nenpòt konfigirasyon lokal yo.
    `,
    cookie_consent_text: "Nou itilize bonbon debaz pou asire sit entènèt la fonksyone kòrèkteman, tankou kenbe sesyon ou aktif, sove preferans lang ou, ak lòt konfigirasyon koutim.",
    read_policy: "Li Règleman sou bonbon",
    support_title: "Kontakte Sipò",
    support_subject_label: "Sijè",
    support_message_label: "Mesaj",
    support_submit_button: "Voye mesaj",
    support_hint: "Remak: Sa a pral louvri aplikasyon imel default ou a pou voye mesaj la.",
    support_success_msg: "Louvri aplikasyon imel ou a...",
    support_error_msg: "Echwe pou voye mesaj. Tanpri eseye ankò pita.",
    explorer_title: "Explorer",
    history_title: "Istwa",
    animation_title: "Animasyon",
    config_title: "Konfigirasyon",
    tool_mouse: "Chwazi (Ctrl+M)",
    tool_brush: "Bwòs (Ctrl+B)",
    tool_brush_mode: "Blete mòd (Soli/Klè)",
    tool_eraser: "Gom (Ctrl+E)",
    tool_brush_size: "Ajiste gwosè bwòs",
    tool_bucket: "Ranpli (Ctrl+F)",
    tool_eyedropper: "Eyedropper",
    tool_grid: "Kadriyaj (Ctrl+Maj+B)",
    tool_rotate: "Vire (Ctrl + Shift + R)",
    tool_flip_h: "Flip H (Ctrl + Shift + H)",
    tool_flip_v: "Flip V (Ctrl+Maj+V)",
    tool_transpose: "Transpoze (Ctrl+Maj+T)",
    label_width: "Lajè",
    label_height: "Wotè",
    label_frames: "Kantite ankadreman",
    label_animation: "Style animasyon",
    label_background_color: "Koulè background",
    label_interval: "Entèval",
    tool_anim_config: "Konfigirasyon Animasyon",
    label_new_width: "Nouvo Lajè",
    label_new_height: "Nouvo Wotè",
    label_apply: "Aplike",
    label_colors: "Koulè",
    label_size: "Gwosè",
    label_tolerance: "Tolerans",
    val_horizontal: "Orizontal",
    val_vertical: "Vètikal",
    val_sequence: "Sekans",
    val_bounce: "Rebondisman",
    val_random: "O aza",
    val_solid: "Solid",
    val_clear: "Klè",
    action_add_sheet: "Nouvo Fèy",
    action_import: "Enpòte",
    action_export: "Ekspòtasyon",
    action_sort_projects: "Triye",
    sort_date_old: "Pi Gran Premye",
    sort_date_new: "Dernye Premye",
    sort_name_az: "Non (A-Z)",
    sort_name_za: "Non (Z-A)",
    action_new_sprite: "Nouvo luten",
    action_new_project: "Nouvo Pwojè",
    modal_save_all_title: "Sove Tout Chanjman yo",
    modal_save_all_desc: "Chwazi byen yo pou konsève pou:",
    modal_save_selected: "Sove Chwazi yo",
    action_saved: "Sove",
    modal_create_sprite_title: "Kreye nouvo luten",
    modal_create_project_title: "Kreye yon nouvo pwojè",
    modal_add_sheet_title: "Ajoute nouvo fèy",
    modal_rename_sheet_title: "Chanje non fèy la",
    modal_rename_sprite_title: "Chanje non Sprite",
    modal_delete_sprite_title: "Efase Sprite",
    modal_delete_project_title: "Efase pwojè",
    modal_delete_sheet_title: "Efase Fèy",
    placeholder_sprite_name: "Non",
    placeholder_project_name: "Non",
    placeholder_sheet_name: "Non",
    placeholder_new_name: "Nouvo Non",
    action_create: "Kreye",
    action_add: "Ajoute",
    action_rename: "Chanje non",
    action_duplicate: "Diplike",
    action_delete: "Efase",
    action_cancel: "Anile",
    confirm_delete_sprite: "Èske w sèten ou vle efase sprite sa a?",
    confirm_delete_project: "Èske w sèten ou vle efase pwojè sa a? Tout sprite yo pral retire.",
    confirm_delete_sheet: "Èske w sèten ou vle efase fèy sa a?",
    err_select_sprite: "Tanpri chwazi yon luten an premye.",
    err_select_project: "Tanpri chwazi yon pwojè an premye.",
    err_name_empty: "Non pa ka vid.",
    err_sprite_exists: "Yon luten ki gen non sa a deja egziste.",
    err_project_exists: "Yon pwojè ki gen non sa a deja egziste.",
    err_no_content: "Pa gen kontni pou konsève pou.",
    err_no_changes: "Pa gen chanjman pou sove.",
    err_delete_last_sheet: "Pa ka efase dènye fèy la.",
    err_extract_frames: "Pa t 'kapab ekstrè okenn ankadreman.",
    err_indexeddb: "Echwe pou sove lokalman. Navigatè w la ka pa sipòte IndexedDB.",
    msg_upload_success: "Téléchargement siksè: {0}",
    msg_upload_failed: "Telechaje echwe: {0}",
    msg_save_success: "Sove siksè.",
    msg_saving: "Ekonomize...",
    msg_multi_save_result: "Sove {0} byen yo. {1} echèk.",
    menu_title: "Menu",
    menu_save: "Sove",
    menu_save_all: "Sove tout",
    menu_support: "Kontakte Sipò",
    label_local_storage: "Depo lokal yo",
    label_sign_in: "Enskri",
    modal_export_title: "Ekspòtasyon Sprite",
    label_filename: "Non fichye",
    label_format: "Fòma",
    action_export_confirm: "Ekspòtasyon",
};

export default translations;
